/* theme.js — Headgear Theme v2 */
(function () {
  'use strict';

  /* -------------------------------------------------------
     UTILITIES
  ------------------------------------------------------- */
  function $(sel, ctx) { return (ctx || document).querySelector(sel); }
  function $$(sel, ctx) { return Array.from((ctx || document).querySelectorAll(sel)); }
  function money(cents) {
    return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 2 }).format(cents / 100);
  }
  function esc(str) {
    const d = document.createElement('div');
    d.appendChild(document.createTextNode(String(str)));
    return d.innerHTML;
  }

  /* -------------------------------------------------------
     SHOPIFY CART API
  ------------------------------------------------------- */
  const cartText = window.hgCartText || {};
  const Cart = {
    async get()           { return fetch('/cart.js').then(r => r.json()); },
    async add(id, qty, props) {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id, quantity: qty, properties: props })
      }).then(r => { if (!r.ok) throw r; return r.json(); });
    },
    async change(key, qty) {
      return fetch((window.Shopify?.routes?.root || '/') + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      }).then(r => { if (!r.ok) throw new Error('Cart change failed'); return r.json(); });
    }
  };

  /* -------------------------------------------------------
     HEADER: scroll state
  ------------------------------------------------------- */
  const siteHeader = $('#site-header');
  if (siteHeader) {
    let ticking = false;
    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          siteHeader.classList.toggle('is-scrolled', window.scrollY > 8);
          ticking = false;
        });
        ticking = true;
      }
    }, { passive: true });
  }

  /* -------------------------------------------------------
     MOBILE MENU
  ------------------------------------------------------- */
  const menuToggle = $('#mobile-menu-toggle');
  const mobileNav  = $('#mobile-nav');
  if (menuToggle && mobileNav) {
    menuToggle.addEventListener('click', () => {
      const open = menuToggle.classList.toggle('is-open');
      mobileNav.classList.toggle('is-open', open);
      menuToggle.setAttribute('aria-expanded', open);
      mobileNav.setAttribute('aria-hidden', !open);
    });
  }

  /* -------------------------------------------------------
     CURRENCY SELECTOR
  ------------------------------------------------------- */
  const currencySel = $('#currency-selector');
  if (currencySel) {
    const btn = currencySel.querySelector('.currency-btn');
    btn && btn.addEventListener('click', (e) => {
      e.stopPropagation();
      const open = currencySel.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open);
    });
    document.addEventListener('click', (e) => {
      if (!currencySel.contains(e.target)) {
        currencySel.classList.remove('is-open');
        btn && btn.setAttribute('aria-expanded', false);
      }
    });
  }

  /* Keep footer currency label text in sync with the select value */
  const footerCurrSel = $('#footer-currency-select');
  if (footerCurrSel) {
    const footerLabel = footerCurrSel.previousElementSibling;
    function syncFooterLabel() {
      if (footerLabel) {
        // Rebuild label: icon + selected ISO code
        const iso = footerCurrSel.value;
        footerLabel.childNodes[footerLabel.childNodes.length - 1].textContent = ' ' + iso;
      }
    }
    footerCurrSel.addEventListener('change', syncFooterLabel);
  }

  /* -------------------------------------------------------
     SEARCH MODAL
  ------------------------------------------------------- */
  const searchModal    = $('#search-modal');
  const searchOpen     = $('#search-open');
  const searchClose    = $('#search-close');
  const searchBackdrop = $('#search-backdrop');
  const searchInput    = $('#search-input');

  function openSearch() {
    if (!searchModal) return;
    searchModal.classList.add('is-open');
    searchModal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    setTimeout(() => searchInput && searchInput.focus(), 50);
  }
  function closeSearch() {
    if (!searchModal) return;
    searchModal.classList.remove('is-open');
    searchModal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  searchOpen    && searchOpen.addEventListener('click', openSearch);
  searchClose   && searchClose.addEventListener('click', closeSearch);
  searchBackdrop && searchBackdrop.addEventListener('click', closeSearch);

  /* -------------------------------------------------------
     CART DRAWER
  ------------------------------------------------------- */
  const cartDrawer  = $('#cart-drawer');
  const cartOverlay = $('#cart-overlay');
  const cartOpenBtn = $('#cart-open');
  const cartCloseBtn= $('#cart-close');
  const cartBody    = $('#cart-drawer-body');
  const cartFooter  = $('#cart-drawer-footer');
  const cartCount   = $('#cart-count');

  function setCartCount(n) {
    if (!cartCount) return;
    cartCount.textContent = n;
    cartCount.style.display = n > 0 ? 'flex' : 'none';
  }

  function openCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('is-open');
    cartOverlay.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden', 'false');
    cartOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    renderCartDrawer();
  }
  function closeCartDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('is-open');
    cartOverlay.classList.remove('is-open');
    cartDrawer.setAttribute('aria-hidden', 'true');
    cartOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  cartOpenBtn  && cartOpenBtn.addEventListener('click', openCartDrawer);
  cartCloseBtn && cartCloseBtn.addEventListener('click', closeCartDrawer);
  cartOverlay  && cartOverlay.addEventListener('click', closeCartDrawer);

  async function renderCartDrawer() {
    if (!cartBody) return;
    cartBody.innerHTML = '<div class="drawer-empty"><p>Loading…</p></div>';
    const cart = await Cart.get();
    setCartCount(cart.item_count);

    if (cart.item_count === 0) {
      cartBody.innerHTML = '<div class="drawer-empty"><svg width="40" height="40" viewBox="0 0 40 40" fill="none"><path d="M5 5H9L14 28H31L36 12H14" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/><circle cx="17" cy="33" r="2.5" fill="currentColor"/><circle cx="29" cy="33" r="2.5" fill="currentColor"/></svg><p>Your cart is empty.</p></div>';
      cartFooter.innerHTML = '';
      return;
    }

    cartBody.innerHTML = cart.items.map(item => {
      const imgSrc = item.featured_image ? item.featured_image.url.replace(/\?.*/, '') + '?width=160' : '';
      const variantLine = (item.variant_title && item.variant_title !== 'Default Title')
        ? `<p class="drawer-item__variant">${esc(item.variant_title)}</p>` : '';
      return `
        <div class="drawer-item" data-key="${item.key}">
          <div class="drawer-item__img">
            <img src="${imgSrc}" alt="${esc(item.product_title)}" width="68" height="68" loading="lazy">
          </div>
          <div>
            <p class="drawer-item__title">${esc(item.product_title)}</p>
            ${variantLine}
            <div class="drawer-item__meta">
              <div class="qty-control">
                <button class="qty-btn" data-drawer-minus data-key="${item.key}" aria-label="Decrease">−</button>
                <input class="qty-input" type="number" value="${item.quantity}" min="0"
                       data-drawer-qty data-key="${item.key}" style="width:36px" aria-label="Quantity">
                <button class="qty-btn" data-drawer-plus data-key="${item.key}" aria-label="Increase">+</button>
              </div>
              <button type="button" class="hg-cart-remove" data-drawer-remove data-key="${item.key}" aria-label="${esc(cartText.remove)}: ${esc(item.product_title)}"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M3 6h18M9 6V4h6v2M5 6l1 14h12l1-14M10 10v6M14 10v6" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg><span>${esc(cartText.remove)}</span></button>
              <span class="drawer-item__price">${money(item.final_line_price)}</span>
            </div>
          </div>
        </div>
      `;
    }).join('');

    cartFooter.innerHTML = `
      <div class="drawer-total">
        <span>Total</span>
        <span>${money(cart.total_price)}</span>
      </div>
      <a href="/checkout" class="btn btn--gold btn--full">Checkout</a>
      <a href="/cart" class="btn btn--outline btn--full" style="margin-top:8px">View Cart</a>
    `;

    let updating = false;
    async function changeDrawer(key, quantity) {
      if (updating || !Number.isInteger(quantity) || quantity < 0) return;
      updating = true;
      cartBody.querySelector('[data-cart-error]')?.remove();
      cartBody.setAttribute('aria-busy', 'true');
      cartBody.querySelectorAll('button,input').forEach(el => el.disabled = true);
      cartFooter.querySelectorAll('a').forEach(el => { el.setAttribute('aria-disabled','true'); el.tabIndex = -1; });
      try {
        await Cart.change(key, quantity);
        await renderCartDrawer();
        (cartBody.querySelector('[data-drawer-remove]') || cartCloseBtn)?.focus();
      } catch (error) {
        const message = document.createElement('p');
        message.className = 'hg-cart-error'; message.dataset.cartError = '';
        message.setAttribute('role','alert'); message.textContent = cartText.error;
        cartBody.append(message);
      } finally {
        updating = false;
        cartBody.removeAttribute('aria-busy');
        cartBody.querySelectorAll('button,input').forEach(el => el.disabled = false);
        cartFooter.querySelectorAll('a').forEach(el => { el.removeAttribute('aria-disabled'); el.removeAttribute('tabindex'); });
      }
    }
    cartBody.querySelectorAll('[data-drawer-remove],[data-drawer-minus],[data-drawer-plus]').forEach(btn => {
      btn.addEventListener('click', () => {
        const input = btn.closest('.drawer-item').querySelector('[data-drawer-qty]');
        const quantity = btn.hasAttribute('data-drawer-remove') ? 0 : Math.max(0, Number(input.value) + (btn.hasAttribute('data-drawer-plus') ? 1 : -1));
        changeDrawer(btn.dataset.key, quantity);
      });
    });
    cartBody.querySelectorAll('[data-drawer-qty]').forEach(input => {
      input.addEventListener('change', () => changeDrawer(input.dataset.key, Number(input.value)));
    });
  }

  // Init cart count on load
  Cart.get().then(c => setCartCount(c.item_count)).catch(() => {});

  /* -------------------------------------------------------
     PRODUCT GALLERY (product page)
  ------------------------------------------------------- */
  const galleryMain   = $('#gallery-main');
  const galleryThumbs = $('#gallery-thumbs');
  const galleryPrev   = $('#gallery-prev');
  const galleryNext   = $('#gallery-next');
  const galleryExpand = $('#gallery-expand');
  const galleryCounter = $('#gallery-counter');

  let galleryIndex = 0;

  if (galleryMain) {
    const slides     = $$('.gallery-slide', galleryMain);
    const thumbBtns  = galleryThumbs ? $$('.gallery-thumb', galleryThumbs) : [];
    const totalSlides = slides.length;

    function goToSlide(i) {
      if (totalSlides === 0) return;
      i = ((i % totalSlides) + totalSlides) % totalSlides;
      slides[galleryIndex].classList.remove('is-active');
      thumbBtns[galleryIndex] && thumbBtns[galleryIndex].classList.remove('is-active');
      galleryIndex = i;
      slides[galleryIndex].classList.add('is-active');
      thumbBtns[galleryIndex] && thumbBtns[galleryIndex].classList.add('is-active');
      if (galleryCounter) galleryCounter.textContent = `${galleryIndex + 1} / ${totalSlides}`;
      // Scroll thumb into view
      thumbBtns[galleryIndex] && thumbBtns[galleryIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
    }

    galleryPrev && galleryPrev.addEventListener('click', () => goToSlide(galleryIndex - 1));
    galleryNext && galleryNext.addEventListener('click', () => goToSlide(galleryIndex + 1));

    thumbBtns.forEach((btn, i) => {
      btn.addEventListener('click', () => goToSlide(i));
    });

    // Click main image → open lightbox
    slides.forEach((slide, i) => {
      const img = slide.querySelector('.gallery-slide__img');
      if (img) img.addEventListener('click', () => openLightbox(i));
    });
    galleryExpand && galleryExpand.addEventListener('click', () => openLightbox(galleryIndex));

    // Touch swipe on gallery main
    let touchX = null;
    galleryMain.addEventListener('touchstart', e => { touchX = e.touches[0].clientX; }, { passive: true });
    galleryMain.addEventListener('touchend', e => {
      if (touchX === null) return;
      const dx = e.changedTouches[0].clientX - touchX;
      if (Math.abs(dx) > 40) goToSlide(galleryIndex + (dx < 0 ? 1 : -1));
      touchX = null;
    }, { passive: true });
  }

  /* -------------------------------------------------------
     LIGHTBOX
  ------------------------------------------------------- */
  const lightbox        = $('#lightbox');
  const lightboxBackdrop= $('#lightbox-backdrop');
  const lightboxClose   = $('#lightbox-close');
  const lightboxPrev    = $('#lightbox-prev');
  const lightboxNext    = $('#lightbox-next');
  const lightboxStage   = $('#lightbox-stage');
  const lightboxCounter = $('#lightbox-counter');
  const lightboxThumbs  = $('#lightbox-thumbs');

  let lightboxIndex = 0;
  let lightboxMedia = [];

  if (lightbox && window.__product) {
    lightboxMedia = window.__product.media || [];

    // Build thumb strip
    if (lightboxThumbs) {
      lightboxThumbs.innerHTML = lightboxMedia.map((m, i) => `
        <div class="lightbox-thumb" data-lb-index="${i}">
          <img src="${m.preview_image ? m.preview_image.src + '&width=120' : ''}" alt="View ${i+1}" width="52" height="52" loading="lazy">
        </div>
      `).join('');

      lightboxThumbs.querySelectorAll('.lightbox-thumb').forEach(t => {
        t.addEventListener('click', () => goToLightbox(parseInt(t.dataset.lbIndex)));
      });
    }

    // Hide nav if only 1
    if (lightboxMedia.length <= 1) {
      lightboxPrev && (lightboxPrev.style.display = 'none');
      lightboxNext && (lightboxNext.style.display = 'none');
    }
  }

  function openLightbox(i) {
    if (!lightbox) return;
    lightboxIndex = i || 0;
    renderLightboxSlide();
    lightbox.classList.add('is-open');
    lightbox.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    lightboxClose && lightboxClose.focus();
  }

  function closeLightbox() {
    if (!lightbox) return;
    lightbox.classList.remove('is-open');
    lightbox.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  function goToLightbox(i) {
    if (!lightboxMedia.length) return;
    lightboxIndex = ((i % lightboxMedia.length) + lightboxMedia.length) % lightboxMedia.length;
    renderLightboxSlide();
  }

  function renderLightboxSlide() {
    if (!lightboxStage || !lightboxMedia.length) return;
    const m = lightboxMedia[lightboxIndex];
    if (!m) return;

    if (m.media_type === 'video') {
      const src = m.sources && m.sources[0] ? m.sources[0].url : '';
      lightboxStage.innerHTML = `<video src="${src}" controls playsinline autoplay style="max-width:min(90vw,900px);max-height:75vh;border-radius:4px"></video>`;
    } else {
      const fullSrc = m.preview_image ? m.preview_image.src.replace(/\?.*/, '') + '?width=1800' : '';
      lightboxStage.innerHTML = `<img src="${fullSrc}" alt="Product view ${lightboxIndex + 1}" loading="lazy">`;
    }

    if (lightboxCounter) lightboxCounter.textContent = `${lightboxIndex + 1} / ${lightboxMedia.length}`;

    // Update thumb active state
    lightboxThumbs && lightboxThumbs.querySelectorAll('.lightbox-thumb').forEach((t, i) => {
      t.classList.toggle('is-active', i === lightboxIndex);
    });
  }

  lightboxClose    && lightboxClose.addEventListener('click', closeLightbox);
  lightboxBackdrop && lightboxBackdrop.addEventListener('click', closeLightbox);
  lightboxPrev     && lightboxPrev.addEventListener('click', () => goToLightbox(lightboxIndex - 1));
  lightboxNext     && lightboxNext.addEventListener('click', () => goToLightbox(lightboxIndex + 1));

  // Keyboard navigation
  document.addEventListener('keydown', e => {
    if (lightbox && lightbox.classList.contains('is-open')) {
      if (e.key === 'ArrowLeft')  goToLightbox(lightboxIndex - 1);
      if (e.key === 'ArrowRight') goToLightbox(lightboxIndex + 1);
      if (e.key === 'Escape')     closeLightbox();
    }
    if (searchModal && searchModal.classList.contains('is-open')) {
      if (e.key === 'Escape') closeSearch();
    }
  });

  // Touch swipe on lightbox
  if (lightbox) {
    let lbTouchX = null;
    lightbox.addEventListener('touchstart', e => { lbTouchX = e.touches[0].clientX; }, { passive: true });
    lightbox.addEventListener('touchend', e => {
      if (lbTouchX === null) return;
      const dx = e.changedTouches[0].clientX - lbTouchX;
      if (Math.abs(dx) > 40) goToLightbox(lightboxIndex + (dx < 0 ? 1 : -1));
      lbTouchX = null;
    }, { passive: true });
  }

  /* -------------------------------------------------------
     VARIANT SELECTION
  ------------------------------------------------------- */
  const productForm = $('#product-form');

  if (productForm && window.__product && !window.__product.hasOnlyDefaultVariant) {
    const variants  = window.__product.variants;
    let selectedOptions = {};

    // Init selected options from checked radios
    $$('.option-swatch', productForm).forEach(swatch => {
      const radio = swatch.querySelector('.option-radio');
      if (radio && radio.checked) {
        selectedOptions[swatch.dataset.optionIndex] = swatch.dataset.value;
      }
    });

    // Handle swatch click (use click on label, not relying on radio change)
    $$('.option-swatch', productForm).forEach(swatch => {
      swatch.addEventListener('click', () => {
        const idx = swatch.dataset.optionIndex;
        const val = swatch.dataset.value;

        // Deselect siblings, select this
        const group = productForm.querySelectorAll(`.option-swatch[data-option-index="${idx}"]`);
        group.forEach(s => {
          s.classList.remove('is-selected');
          const r = s.querySelector('.option-radio');
          if (r) r.checked = false;
        });
        swatch.classList.add('is-selected');
        const radio = swatch.querySelector('.option-radio');
        if (radio) radio.checked = true;

        // Update display label
        const labelVal = productForm.querySelector(`#option-val-${idx}`);
        if (labelVal) labelVal.textContent = val;

        selectedOptions[idx] = val;
        updateVariantFromSelection();
      });
    });

    function updateVariantFromSelection() {
      // Build option array in order
      const opts = [];
      const numOptions = Object.keys(selectedOptions).length;
      for (let i = 0; i < numOptions; i++) {
        opts.push(selectedOptions[String(i)]);
      }

      // Find matching variant
      const match = variants.find(v => {
        return opts.every((opt, i) => v['option' + (i + 1)] === opt);
      });

      if (!match) return;

      // Update hidden variant id
      const variantInput = $('#variant-id');
      if (variantInput) variantInput.value = match.id;

      // Update price display
      const priceEl = $('#product-price');
      if (priceEl) {
        let html = '';
        if (match.compare_at_price && match.compare_at_price > match.price) {
          html += `<s class="price-compare">${money(match.compare_at_price)}</s>`;
          const pct = Math.round((match.compare_at_price - match.price) * 100 / match.compare_at_price);
          html += `<span class="price-current">${money(match.price)}</span>`;
          html += `<span class="price-saving">Save ${pct}%</span>`;
        } else {
          html = `<span class="price-current">${money(match.price)}</span>`;
        }
        priceEl.innerHTML = html;
      }

      // Update ATC button
      const atcBtn = $('#add-to-cart');
      if (atcBtn) {
        atcBtn.disabled = !match.available;
        atcBtn.textContent = match.available ? 'Add to Cart' : 'Sold Out';
      }

      // Update gallery to variant's image if available
      if (match.featured_image && galleryMain) {
        const targetSrc = match.featured_image.src.replace(/\?.*/, '');
        const slides = $$('.gallery-slide', galleryMain);
        slides.forEach((slide, i) => {
          const img = slide.querySelector('.gallery-slide__img');
          if (img) {
            const slideSrc = img.src.replace(/\?.*/, '').replace(/&width=\d+/, '');
            if (slideSrc.includes(targetSrc.split('/').pop().split('.')[0])) {
              // Go to this slide in gallery
              if (typeof goToSlide !== 'undefined') {
                // goToSlide defined in outer scope — call it
              }
            }
          }
        });
      }

      // Update volume pricing if shown
      if (window.__showVolumePricing) renderVolumeTiers(match.price);
    }

    // Trigger initial render if volume pricing is on
    if (window.__showVolumePricing) {
      const firstVariant = variants.find(v => v.id === window.__product.currentVariantId) || variants[0];
      if (firstVariant) renderVolumeTiers(firstVariant.price);
    }
  }

  /* -------------------------------------------------------
     VOLUME PRICING
  ------------------------------------------------------- */
  function buildTiersFromSettings() {
    // Read from DOM data attributes injected by Liquid, or use window.__volumeTiers
    const tiers = [];
    // Try to parse from global settings via data attributes
    const container = $('#volume-pricing');
    if (!container) return tiers;

    // Tiers 1-6 from settings (injected as data attrs on container if available)
    // Otherwise we read from window.__volumeTiers if provided
    if (window.__volumeTiers && window.__volumeTiers.length) {
      return window.__volumeTiers;
    }

    // Fallback: read from data-* on volume-pricing element
    for (let i = 1; i <= 6; i++) {
      const min = parseInt(container.dataset[`tier${i}Min`] || 0);
      const max = parseInt(container.dataset[`tier${i}Max`] || 0);
      const disc = parseFloat(container.dataset[`tier${i}Discount`] || 0);
      if (min > 0 && disc > 0) tiers.push({ min, max, discount: disc });
    }
    return tiers;
  }

  function renderVolumeTiers(basePriceCents) {
    const tiersEl = $('#volume-tiers');
    const hintEl  = $('#volume-savings-hint');
    const priceEl = $('#product-price');
    if (!tiersEl) return;

    const tiers = buildTiersFromSettings();
    const qtyInput = $('#quantity');
    const currentQty = qtyInput ? parseInt(qtyInput.value) || 1 : 1;

    // Find active tier
    const activeTier = tiers.find(t => currentQty >= t.min && (t.max === 0 || currentQty <= t.max));
    const isBaseActive = !activeTier;

    let html = '';

    // Base tier label
    const baseMax = tiers.length && tiers[0].min > 1 ? tiers[0].min - 1 : null;
    const baseLabel = baseMax ? `1–${baseMax}` : '1+';

    html += `
      <div class="volume-tier ${isBaseActive ? 'is-active-tier' : ''}">
        <p class="volume-tier__qty">${baseLabel}</p>
        <p class="volume-tier__price">${money(basePriceCents)}</p>
        <p class="volume-tier__tag volume-tier__tag--base">Base</p>
      </div>
    `;

    tiers.forEach(tier => {
      const tierPrice = Math.round(basePriceCents * (1 - tier.discount / 100));
      const maxLabel  = tier.max > 0 ? `${tier.min}–${tier.max}` : `${tier.min}+`;
      const isActive  = activeTier && activeTier.min === tier.min;
      html += `
        <div class="volume-tier ${isActive ? 'is-active-tier' : ''}">
          <p class="volume-tier__qty">${maxLabel}</p>
          <p class="volume-tier__price">${money(tierPrice)}</p>
          <p class="volume-tier__tag volume-tier__tag--discount">${tier.discount}% off</p>
        </div>
      `;
    });

    tiersEl.innerHTML = html;

    // Update main product price to reflect per-unit price at current qty.
    // Price always comes from basePriceCents (passed in by the caller). We look
    // the variant up only to read compare_at_price, and never bail if it's
    // missing — some products (e.g. those using the personalizer app) don't keep
    // #variant-id in sync, which previously froze the displayed price at base.
    if (priceEl) {
      const variantId = parseInt($('#variant-id') ? $('#variant-id').value : 0, 10);
      const variant = (window.__product && window.__product.variants.find(v => v.id === variantId)) || null;
      const displayPrice = activeTier
        ? Math.round(basePriceCents * (1 - activeTier.discount / 100))
        : basePriceCents;
      let priceHtml = '';
      if (activeTier) {
        priceHtml = `
          <s class="price-compare">${money(basePriceCents)}</s>
          <span class="price-current">${money(displayPrice)}</span>
          <span class="price-saving">${activeTier.discount}% off</span>
        `;
      } else if (variant && variant.compare_at_price && variant.compare_at_price > basePriceCents) {
        const pct = Math.round((variant.compare_at_price - basePriceCents) * 100 / variant.compare_at_price);
        priceHtml = `<s class="price-compare">${money(variant.compare_at_price)}</s><span class="price-current">${money(basePriceCents)}</span><span class="price-saving">Save ${pct}%</span>`;
      } else {
        priceHtml = `<span class="price-current">${money(basePriceCents)}</span>`;
      }
      priceEl.innerHTML = priceHtml;
    }

    // Savings hint
    if (hintEl) {
      if (activeTier) {
        const tierPrice = Math.round(basePriceCents * (1 - activeTier.discount / 100));
        hintEl.innerHTML = `<strong>✓ ${activeTier.discount}% discount applied</strong> — ${money(tierPrice)}/hat`;
      } else if (tiers.length > 0) {
        const nextTier = tiers[0];
        const needed   = nextTier.min - currentQty;
        const tierPrice = Math.round(basePriceCents * (1 - nextTier.discount / 100));
        hintEl.innerHTML = `<svg width="12" height="12" viewBox="0 0 12 12" fill="none" style="display:inline;vertical-align:middle;margin-right:4px"><path d="M6 1L7.5 4.5H11L8.5 6.5L9.5 10L6 8L2.5 10L3.5 6.5L1 4.5H4.5L6 1Z" fill="#c9a84c"/></svg> Add <strong>${needed} more</strong> to unlock <em>${nextTier.discount}% off</em> — just ${money(tierPrice)}/hat`;
      } else {
        hintEl.innerHTML = '';
      }
    }

    // Click tier to set quantity
    tiersEl.querySelectorAll('.volume-tier').forEach((el, i) => {
      el.addEventListener('click', () => {
        const tier = i === 0 ? null : tiers[i - 1];
        if (qtyInput) {
          qtyInput.value = tier ? tier.min : 1;
          qtyInput.dispatchEvent(new Event('change'));
        }
      });
    });
  }

  // Initial render for single-variant products (hasOnlyDefaultVariant skips the block above)
  if (window.__showVolumePricing && window.__product && window.__product.hasOnlyDefaultVariant) {
    const v = window.__product.variants[0];
    if (v) renderVolumeTiers(v.price);
  }

  // Re-render volume pricing on qty change.
  // Resolve the unit price defensively: selected variant id → current variant
  // id → first variant. Previously this bailed out when #variant-id didn't match
  // a known variant, which left the price frozen at base for personalizer products.
  const qtyInput = $('#quantity');
  if (qtyInput && window.__showVolumePricing && window.__product) {
    const variants = window.__product.variants || [];
    qtyInput.addEventListener('change', () => {
      const selId   = parseInt($('#variant-id') ? $('#variant-id').value : 0, 10);
      const variant = variants.find(v => v.id === selId)
                   || variants.find(v => v.id === window.__product.currentVariantId)
                   || variants[0];
      if (variant) renderVolumeTiers(variant.price);
    });
  }

  /* -------------------------------------------------------
     QUANTITY CONTROLS
  ------------------------------------------------------- */
  $$('.qty-btn:not([data-drawer-minus]):not([data-drawer-plus])').forEach(btn => {
    btn.addEventListener('click', () => {
      const input = btn.closest('.qty-control').querySelector('.qty-input');
      if (!input) return;
      const minVal = parseInt(input.min) || 0;
      let val = parseInt(input.value) || 1;
      val = btn.dataset.action === 'plus' ? val + 1 : Math.max(minVal, val - 1);
      input.value = val;
      input.dispatchEvent(new Event('change'));
    });
  });

  /* -------------------------------------------------------
     FILE UPLOAD
  ------------------------------------------------------- */
  const uploadDrop     = $('#upload-drop');
  const uploadInput    = $('#logo-upload');
  const uploadFilename = $('#upload-filename');

  if (uploadInput) {
    uploadInput.addEventListener('change', () => {
      const f = uploadInput.files[0];
      if (f && uploadFilename) { uploadFilename.textContent = f.name; uploadDrop && uploadDrop.classList.add('has-file'); }
    });
  }
  if (uploadDrop) {
    ['dragover','dragenter'].forEach(evt => {
      uploadDrop.addEventListener(evt, e => { e.preventDefault(); uploadDrop.classList.add('is-over'); });
    });
    uploadDrop.addEventListener('dragleave', () => uploadDrop.classList.remove('is-over'));
    uploadDrop.addEventListener('drop', e => {
      e.preventDefault();
      uploadDrop.classList.remove('is-over');
      if (uploadInput && e.dataTransfer.files[0]) {
        // Can't directly assign to FileList, but we can read the file name
        const f = e.dataTransfer.files[0];
        if (uploadFilename) uploadFilename.textContent = f.name;
        uploadDrop.classList.add('has-file');
      }
    });
  }

  /* -------------------------------------------------------
     ADD TO CART FORM
  ------------------------------------------------------- */
  if (productForm) {
    productForm.addEventListener('submit', async e => {
      e.preventDefault();
      const atcBtn = $('#add-to-cart');
      const variantIdEl = $('#variant-id');
      const qtyEl = $('#quantity');
      const id  = variantIdEl ? parseInt(variantIdEl.value) : 0;
      const qty = qtyEl ? parseInt(qtyEl.value) || 1 : 1;
      if (!id) return;

      // Collect properties
      const properties = {};
      productForm.querySelectorAll('[name^="properties["]').forEach(el => {
        if (el.value) {
          const key = el.name.match(/\[([^\]]+)\]/)[1];
          properties[key] = el.value;
        }
      });
      // Logo file name
      const fileEl = $('#logo-upload');
      if (fileEl && fileEl.files[0]) properties['Logo Filename'] = fileEl.files[0].name;

      if (atcBtn) { atcBtn.disabled = true; atcBtn.textContent = 'Adding…'; }

      try {
        await Cart.add(id, qty, properties);
        const cart = await Cart.get();
        setCartCount(cart.item_count);
        if (atcBtn) { atcBtn.textContent = '✓ Added!'; }
        setTimeout(() => {
          if (atcBtn) { atcBtn.textContent = 'Add to Cart'; atcBtn.disabled = false; }
          openCartDrawer();
        }, 800);
      } catch (err) {
        console.error(err);
        if (atcBtn) { atcBtn.textContent = 'Error — try again'; atcBtn.disabled = false; }
      }
    });
  }

  /* -------------------------------------------------------
     CART PAGE (full cart, not drawer)
  ------------------------------------------------------- */
  let cartPageUpdating = false;
  async function changeCartPage(key, quantity) {
    if (cartPageUpdating || !key || !Number.isInteger(quantity) || quantity < 0) return;
    cartPageUpdating = true;
    const page = $('.cart-page');
    const error = $('[data-cart-error]', page);
    if (error) error.hidden = true;
    page.setAttribute('aria-busy', 'true');
    page.querySelectorAll('button,input').forEach(el => el.disabled = true);
    try {
      await Cart.change(key, quantity);
      window.location.reload();
    } catch (failure) {
      if (error) { error.textContent = cartText.error; error.hidden = false; }
      page.querySelectorAll('button,input').forEach(el => el.disabled = false);
      page.removeAttribute('aria-busy');
      cartPageUpdating = false;
    }
  }
  $$('.cart-item .qty-input').forEach(input => {
    input.addEventListener('change', () => changeCartPage(input.dataset.key, Number(input.value)));
  });
  $$('.cart-item__remove').forEach(btn => {
    btn.addEventListener('click', () => changeCartPage(btn.dataset.key, 0));
  });

})();
/* ==========================================================================
   Market / country targeting (client-side helper)
   Any element can opt in with:
     data-show-country="CA,US"   → only shown to visitors in those countries
     data-hide-country="US"      → hidden for those countries
     data-show-market="canada"   → only shown in those market handles
   Country/market come from <body data-country data-market>, set by Liquid
   from Shopify Markets' resolved localization.
   ========================================================================== */
(function () {
  var body = document.body;
  if (!body) return;
  var country = (body.getAttribute('data-country') || '').toUpperCase();
  var market  = (body.getAttribute('data-market')  || '').toLowerCase();
  var list = function (v, upper) {
    return (v || '').replace(/\s/g, '').split(',').filter(Boolean)
      .map(function (s) { return upper ? s.toUpperCase() : s.toLowerCase(); });
  };
  var resolve = function (root) {
    (root || document).querySelectorAll('[data-show-country],[data-show-market],[data-hide-country]').forEach(function (el) {
      var ok = true;
      if (el.hasAttribute('data-show-country') && list(el.getAttribute('data-show-country'), true).indexOf(country) === -1) ok = false;
      if (el.hasAttribute('data-show-market')  && list(el.getAttribute('data-show-market'), false).indexOf(market) === -1) ok = false;
      if (el.hasAttribute('data-hide-country') && list(el.getAttribute('data-hide-country'), true).indexOf(country) !== -1) ok = false;
      el.classList.toggle('is-market-visible', ok);
      el.classList.toggle('is-market-hidden', !ok);
    });
  };
  window.HGMarket = { country: country, market: market, resolve: resolve };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { resolve(); });
  else resolve();
  // Re-run when the theme editor re-renders a section
  document.addEventListener('shopify:section:load', function (e) { resolve(e.target); });
})();
